export const designAssetCatalog = {
    'brand.logo.primary': {
        key: 'brand.logo.primary',
        kind: 'brand',
        label: 'Mira logo',
        version: '2026-06-20.1',
        description: 'Primary Mira / 观心 logo used by formal clients.',
        localFallback: '/assets/brand/mira-logo.png',
        ossKey: 'design/brand/mira-logo.png',
        tags: ['brand', 'logo'],
    },
    'texture.botanicalWash': {
        key: 'texture.botanicalWash',
        kind: 'texture',
        label: 'Botanical relationship wash',
        version: '2026-06-20.1',
        description: 'Soft botanical wash for relationship surfaces.',
        localFallback: 'relation-botanical.png',
        ossKey: 'design/textures/relation-botanical.png',
        tags: ['relationship', 'botanical', 'texture'],
    },
    'topic.communication': {
        key: 'topic.communication',
        kind: 'illustration',
        label: 'Quiet lake topic',
        version: '2026-06-20.1',
        description: 'Warm lake illustration for reflective conversation topics.',
        localFallback: 'topic-lake.png',
        ossKey: 'design/topics/topic-lake.png',
        tags: ['topic', 'communication', 'water'],
    },
    'topic.family': {
        key: 'topic.family',
        kind: 'illustration',
        label: 'Leaf topic',
        version: '2026-06-20.1',
        description: 'Leaf and garden illustration for family or relational topics.',
        localFallback: 'topic-leaf.png',
        ossKey: 'design/topics/topic-leaf.png',
        tags: ['topic', 'family', 'leaf'],
    },
    'topic.moving': {
        key: 'topic.moving',
        kind: 'illustration',
        label: 'City topic',
        version: '2026-06-20.1',
        description: 'City illustration for movement, work, and transition topics.',
        localFallback: 'topic-city.png',
        ossKey: 'design/topics/topic-city.png',
        tags: ['topic', 'moving', 'city'],
    },
    'topic.career': {
        key: 'topic.career',
        kind: 'illustration',
        label: 'Hills topic',
        version: '2026-06-20.1',
        description: 'Hills illustration for long-range career and growth topics.',
        localFallback: 'topic-hills.png',
        ossKey: 'design/topics/topic-hills.png',
        tags: ['topic', 'career', 'growth'],
    },
    'topic.reflection': {
        key: 'topic.reflection',
        kind: 'illustration',
        label: 'Reflection topic',
        version: '2026-06-20.1',
        description: 'Reusable fallback for general reflective topics.',
        localFallback: 'topic-lake.png',
        ossKey: 'design/topics/topic-lake.png',
        tags: ['topic', 'reflection'],
    },
    'memory.note': {
        key: 'memory.note',
        kind: 'illustration',
        label: 'Memory notebook',
        version: '2026-06-20.1',
        description: 'Notebook memory illustration for user notes and remembered items.',
        localFallback: 'memory-book.png',
        ossKey: 'design/memory/memory-book.png',
        tags: ['memory', 'note'],
    },
    'memory.insight': {
        key: 'memory.insight',
        kind: 'illustration',
        label: 'Memory tea',
        version: '2026-06-20.1',
        description: 'Tea memory illustration for reflective insights.',
        localFallback: 'memory-tea.png',
        ossKey: 'design/memory/memory-tea.png',
        tags: ['memory', 'insight'],
    },
    'memory.reflection': {
        key: 'memory.reflection',
        kind: 'illustration',
        label: 'Memory lake',
        version: '2026-06-20.1',
        description: 'Lake memory illustration for general memory cards.',
        localFallback: 'memory-lake.png',
        ossKey: 'design/memory/memory-lake.png',
        tags: ['memory', 'reflection'],
    },
    'relationship.partner': {
        key: 'relationship.partner',
        kind: 'avatar',
        label: 'Partner avatar',
        version: '2026-06-20.1',
        description: 'Warm avatar illustration for partner relationships.',
        localFallback: 'avatar-emma.png',
        ossKey: 'design/relationships/avatar-emma.png',
        tags: ['relationship', 'partner', 'avatar'],
    },
    'relationship.family': {
        key: 'relationship.family',
        kind: 'avatar',
        label: 'Family avatar',
        version: '2026-06-20.1',
        description: 'Steady avatar illustration for family relationships.',
        localFallback: 'avatar-dad.png',
        ossKey: 'design/relationships/avatar-dad.png',
        tags: ['relationship', 'family', 'avatar'],
    },
    'relationship.friend': {
        key: 'relationship.friend',
        kind: 'avatar',
        label: 'Friend avatar',
        version: '2026-06-20.1',
        description: 'Light avatar illustration for friend relationships.',
        localFallback: 'avatar-sophie.png',
        ossKey: 'design/relationships/avatar-sophie.png',
        tags: ['relationship', 'friend', 'avatar'],
    },
    'relationship.work': {
        key: 'relationship.work',
        kind: 'avatar',
        label: 'Work relationship avatar',
        version: '2026-06-20.1',
        description: 'Grounded avatar illustration for work relationships.',
        localFallback: 'avatar-michael.png',
        ossKey: 'design/relationships/avatar-michael.png',
        tags: ['relationship', 'work', 'avatar'],
    },
    'hero.lake': {
        key: 'hero.lake',
        kind: 'hero',
        label: 'Lake hero',
        version: '2026-06-20.1',
        description: 'Large warm lake image for Today and topic detail hero surfaces.',
        localFallback: 'lake-hero.png',
        ossKey: 'design/heroes/lake-hero.png',
        tags: ['hero', 'lake', 'today'],
    },
};
export const designAssetKeys = Object.keys(designAssetCatalog);
export function getDesignAsset(key) {
    return designAssetCatalog[key];
}
